import { useQuery } from '@tanstack/react-query';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string) {
  return useQuery<ConversationListItem[]>({
    queryKey: ['conversations', { clientId }],
  });
}
